module.exports = __webpack_public_path__ + "img/buttonotimo.f6cd3eda.png";